import { render, staticRenderFns } from "./MemberInformationTab.vue?vue&type=template&id=25d438d7&"
import script from "./MemberInformationTab.vue?vue&type=script&lang=js&"
export * from "./MemberInformationTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports